module.exports = __webpack_public_path__ + "media/images/flags/16/Liberia-103c6959e50a9ca04cc40cdd026bb72e.png";